export default {
  addEnum: 'Add Enum',
  edit: 'Edit',
  delete: 'Delete',

  enumsKey: 'Enum Key',
  name: 'Name',
  nameEn: 'English Name',
  sort: 'Sort',
  createTime: 'Created At',
  operation: 'Actions',

  addEnumTitle: 'Add Enum',
  editEnumTitle: 'Edit Enum',

  enumsKeyField: 'Enum Key',
  enumsKeyPlaceholder: 'Enter enum key, e.g. robot_type',
  nameField: 'Name',
  namePlaceholder: 'Enter name',
  nameEnField: 'English Name',
  nameEnPlaceholder: 'Enter English name',
  sortField: 'Sort',
  sortPlaceholder: 'Enter sort order',

  enumsKeyRequired: 'Please enter enum key',
  nameRequired: 'Please enter name',
  nameEnRequired: 'Please enter English name',
  sortRequired: 'Please enter sort order',

  cancel: 'Cancel',
  confirm: 'Confirm',

  addSuccess: 'Added successfully',
  editSuccess: 'Updated successfully',
  deleteSuccess: 'Deleted successfully',

  deleteConfirmTitle: 'Confirm Delete',
  deleteConfirmContent: 'Delete "{name}"?',
  deleteConfirm: 'Delete',
}
